// extracted by mini-css-extract-plugin
module.exports = {"topic":"rigcard_topic__GukQi","btn":"rigcard_btn__3DycN","rigspecs":"rigcard_rigspecs__CANbj","rig":"rigcard_rig__3xZBq"};